import { Box, Typography, useTheme } from "@mui/material";
import InfoCircle from "../../../../../media/images/icons/info-circle";

export default function InfoBox() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.primary[50],
        borderRadius: "16px",
        borderColor: "primary.main",
        borderWidth: "1px",
        borderStyle: "solid",
        padding: "8px 8px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: "4px",
        }}
      >
        <InfoCircle color={theme.palette.primary.main} />
        <Typography
          sx={{
            color: "primary.main",
            fontSize: "14px",
          }}
        >
          در صورت نیاز به راهنما درباره بخش‌ها و امکانات بازارگاه می‌توانید
          راهنمای جامع بازارگاه یا آموزش‌های ویدئویی را مشاهده‌کنید:
        </Typography>
      </Box>
    </Box>
  );
}
